// this is an autogenerated file from App/Account/Content/Tasks/New/Content/Board/mutation-update-board.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Tasks_New_Content_Board(
  $id: uuid!
  $stages: jsonb!
  $type: tasks_board_types_enum!
  $metadata: jsonb!
  $name: String!
) {
  tasks_update_board_and_stages(
    id: $id
    name: $name
    type: $type
    metadata: $metadata
    stages: $stages
  ) {
    id
  }
}

`